import styled from 'styled-components';
import ErrorMessage from './ErrorMessage';

const SuccessMessage = styled(ErrorMessage)`
  color: #1cabe2;
`;

export default SuccessMessage;
